import { SITE, OUTLETS, MAPS_EMBED } from "../data/site";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { IconPin, IconArrowUpRight, IconInstagram } from "../components/Icons";

export default function Lokasi() {
  const hq = OUTLETS[0];
  const others = OUTLETS.slice(1);

  return (
    <>
      <section className="mx-auto max-w-6xl px-5 pb-14 pt-28 md:pt-36">
        <Breadcrumbs items={[{ label: "Lokasi", href: "/lokasi/" }]} />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Mampir Langsung</p>
        <h1 className="mt-3 font-display text-4xl uppercase tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Lokasi Outlet Burger Blenger
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-sand sm:text-lg">
          Pusatnya di Barito–Blok M, Jakarta Selatan — plus titik di Fatmawati,
          Bintaro, dan BSD. Datang sore atau malam? Siap-siap antri. It's worth
          the wait.
        </p>
      </section>

      {/* HQ */}
      <section className="mx-auto max-w-6xl px-5" data-testid="hq-section">
        <div className="grid gap-px border border-white/10 bg-white/10 lg:grid-cols-2">
          <div className="bg-coal2 p-8 md:p-10">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cheddar">Outlet Pusat</p>
            <h2 className="mt-3 font-display text-2xl uppercase tracking-wide text-cream sm:text-3xl">
              {hq.name}
            </h2>
            <address className="mt-5 flex items-start gap-3 text-base not-italic leading-relaxed text-sand" data-testid="hq-address">
              <IconPin className="mt-1 h-5 w-5 shrink-0 text-blood" />
              <span>
                {SITE.name}
                <br />
                {SITE.address.street}
                <br />
                {SITE.address.locality}
                <br />
                {SITE.address.region}, {SITE.address.country}
              </span>
            </address>
            <div className="mt-8 flex flex-wrap gap-4">
              <a
                href={hq.maps}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hq-directions-button"
                className="btn-primary"
              >
                Petunjuk Arah <IconArrowUpRight className="h-4 w-4" />
              </a>
              <a
                href={SITE.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hq-instagram-button"
                className="btn-ghost"
              >
                <IconInstagram className="h-4 w-4" /> {SITE.instagramHandle}
              </a>
            </div>
          </div>
          <div className="bg-coal2">
            <iframe
              title="Peta lokasi Burger Blenger Blok M, Jl. Bumi No. 56, Jakarta Selatan"
              src={MAPS_EMBED}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="hq-map-embed"
              className="h-72 w-full border-0 lg:h-full lg:min-h-[380px]"
            />
          </div>
        </div>
      </section>

      {/* Other outlets */}
      <section className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-testid="outlets-list-section">
        <h2 className="font-display text-2xl uppercase tracking-tight text-cream sm:text-3xl">
          Titik lainnya
        </h2>
        <ul className="mt-8 grid gap-px border border-white/10 bg-white/10 md:grid-cols-3">
          {others.map((o) => (
            <li key={o.id} className="bg-coal2 p-7" data-testid={`outlet-card-${o.id}`}>
              <IconPin className="h-5 w-5 text-blood" />
              <h3 className="mt-4 font-display text-xl uppercase tracking-wide text-cream">{o.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-sand">{o.area}</p>
              <a
                href={o.maps}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`outlet-card-${o.id}-directions`}
                className="mt-4 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.15em] text-cheddar transition-colors hover:text-cream"
              >
                Petunjuk arah <IconArrowUpRight className="h-3.5 w-3.5" />
              </a>
            </li>
          ))}
        </ul>
        <p className="mt-8 max-w-2xl border-l-2 border-cheddar pl-4 text-sm leading-relaxed text-sand" data-testid="outlets-note">
          Jam operasional dan ketersediaan tiap outlet bisa berubah. Sebelum
          berangkat, cek update terbaru di Instagram{" "}
          <a
            href={SITE.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="outlets-note-instagram-link"
            className="text-cheddar underline underline-offset-4 hover:text-cream"
          >
            {SITE.instagramHandle}
          </a>{" "}
          atau langsung di Google Maps.
        </p>
      </section>
    </>
  );
}
